import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCompany } from "../../components/context/CompanyContext";
import { titleSetRef } from "../../redux/titleRedux";
import ProductReport from "./productReport";

// Tela dedicada de Relatório de Produtos — acessada pelos cards de Indicadores
// Produtos ("Produto", "Produto com Venda", "Avise-me quando chegar").
export default function RelatorioProdutos() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { slug } = useCompany();

  useEffect(() => {
    dispatch(titleSetRef({ title: "Relatório de Produtos" }));
    window.scrollTo(0, 0);
  }, [dispatch]);

  return (
    <div style={{ padding: "8px 8px 0 0" }}>
      <div
        onClick={() => nav(`/${slug}/indicadoresprodutos`)}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          marginBottom: 12,
          cursor: "pointer",
          color: "#6B7280",
          fontSize: 13,
          fontWeight: 600,
          fontFamily: "Manrope",
          padding: "6px 12px",
          borderRadius: 8,
          border: "1px solid #E5E7EB",
          background: "#fff",
          boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
        }}
      >
        ← Voltar para Indicadores
      </div>
      <ProductReport />
    </div>
  );
}
